import axios from 'axios';

import { GET_A2P_COMPLIANCE_STATUS } from './types';

export const getA2PComplianceStatus = () => async (dispatch) => {
	// if (this.props.auth && this.props.auth.twilioNumber) {
	try {
		const res = await axios.get('/api/settings/compliance-status');

		const {
			brandStatus,
			byPassA2PPopup,
			a2pFailed,
			supportEmail,
			isContactInfoFilled,
			isBandwidthNumber,
		} = res.data;

		dispatch({
			type: GET_A2P_COMPLIANCE_STATUS,
			payload: {
				isA2PRegisteredOrInProgress:
					brandStatus === 'APPROVED' || brandStatus === 'PENDING',
				byPassA2PPopup,
				a2pFailed,
				supportEmail,
				isContactInfoFilled,
				isBandwidthNumber,
			},
		});
	} catch (error) {
		console.error('Error fetching A2P compliance status:', error);
	}
};
